// extracted by mini-css-extract-plugin
module.exports = {"ecgsWrapper":"UserEcgs_ecgsWrapper__12GLO","ecgDetailsWrapper":"UserEcgs_ecgDetailsWrapper__292IN"};